<template>
  <div>
    <div v-bind:key="index" v-for="(placeholder, index) in form.placeholders">
      <selectlist
        :name="placeholder.key"
        placeholder="Please Select"
        v-model="form.placeholders[index].value"
        :label="placeholder.label"
        :options="licenseTypes"
        key-name="type"
        label-name="type"
        v-if="
          placeholder.key == 'license_type' ||
            placeholder.key === 'ar_license_type'
        "
      ></selectlist>

      <document-placeholder
        v-model="form.placeholders[index].value"
        :placeholder="placeholder"
        v-else
      ></document-placeholder>
    </div>

    <selectlist
      name="excess"
      placeholder="Please Select"
      v-model="form.excess"
      label="Excess"
      :options="excesses"
      :show-error="form.errors.has('excess')"
      label-name="excess"
      :error-message="form.errors.get('excess')"
      key-name="excess"
    ></selectlist>

    <inputbox
      name="other_excess"
      label="Please specify the excess"
      v-model="form.other_excess"
      :show-error="form.errors.has('other_excess')"
      :error-message="form.errors.get('other_excess')"
      v-if="form.excess == 'Other'"
    ></inputbox>
  </div>
</template>
<script>
import DocumentPlaceholder from '@/components/Modules/Shared/Children/GenerateDocument/DocumentPlaceholder';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    hire: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    }
  },

  components: {
    DocumentPlaceholder
  },

  data() {
    return {
      excesses: [
        { excess: '750.00' },
        { excess: '600.00' },
        { excess: 'Other' }
      ],
      licenseTypes: [
        {
          type: 'Full Car / Full Bike'
        },
        {
          type: 'Full Car / Full Restricted Bike'
        },
        {
          type: 'Full Car / CBT'
        },
        {
          type: 'Full Car'
        },
        {
          type: 'Provisional Car / CBT'
        },
        {
          type: 'Provisional Car / Full Bike'
        },
        {
          type: 'Provisional Car / Full Bike Restricted'
        },
        {
          type: 'Provisional Car'
        }
      ]
    };
  },

  mounted() {
    this.loadPlaceholders();
  },

  methods: {
    loadPlaceholders() {
      if (this.hire.identifier) {
        window.Ajax.get(
          `/hires/${this.hire.identifier}/hire-agreement/placeholders`
        ).then(response => {
          this.form.placeholders = response.data;
        });
      }
    }
  },

  watch: {
    hire() {
      this.loadPlaceholders();
    }
  }
};
</script>
